module.exports = __webpack_public_path__ + "img/State=10.ce3bc9c0.svg";